<template>
  <div class="header-select">
    <a-select show-search option-filter-prop="children" v-model="inventOrgValue" @change="handleChange" :defaultActiveFirstOption="false" :dropdown-match-select-width="false">
      <a-select-option v-for="item in inventOrg" :key="item.realValue">{{ item.label }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HeaderSelect',
  data () {
    return {
      inventOrgValue: ''
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.inventOrgValue = this.inventOrg.length > 0 && this.inventOrg[0].realValue
    this.handleChange(this.inventOrgValue)
  },
  methods: {
    handleChange (val) {
      this.$store.dispatch('SetOrganizationCode', val)
      this.event.$emit("close-all-page");
      this.event.$emit("clean-keep-alive-cache"); // 清除缓存
    }
  }
}
</script>

<style scoped lang="less">
.header-select {
  /deep/.ant-select {
    // width: 150px;
    width: 100%;
  }
  width: 100%;
  padding: 0 10px 0 16px;
}
</style>
